import React, { forwardRef } from 'react';
import { Flex, FlexDirection, type FlexProps } from '../flex/flex.component';

// eslint-disable-next-line react/jsx-props-no-spreading
const Row = forwardRef<HTMLDivElement, FlexProps>((props, ref) => <Flex ref={ref} direction={FlexDirection.Row} {...props} />);

export default Row;
